import { IWizardExecuteAllModel } from "../../../../components/Wizard";
import { ITemplateDataModel } from "./";

export class TemplateExecuteModel implements IWizardExecuteAllModel {

    public id: number;
    public formDataModel: ITemplateDataModel;

    constructor(id: number, formData: ITemplateDataModel) {

        this.id = id;
        this.formDataModel = formData;
    }
}
